import React, {useEffect,useState} from "react";
import {AuthProvider} from './src/utils/AuthContext'
import { navigate } from "gatsby";
import "@fontsource-variable/cuprum";
import "@fontsource-variable/comfortaa";
import AudioPlayerPanel from "./src/components/AudioPlayer";
import { AudioProvider } from "./src/components/AudioContext";
import { RadioProvider } from "./src/components/radiodata";
import "./src/styles/global.css";

const ProtectedRouteHandler = ({ children, location }) => {
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("jwt");
    const protectedRoutes = ["/dashboard"];

    if (protectedRoutes.includes(location.pathname) && !isAuthenticated) {
      navigate("/login");
    }
  }, [location.pathname]);

  return children;
};
const AudioPlayerWrapper = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? <AudioPlayerPanel /> : null;
};
export const wrapPageElement = ({ element, props }) => {
  return (
    <AudioProvider>
      <ProtectedRouteHandler location={props.location}>
      {element}
      <AudioPlayerWrapper />
      </ProtectedRouteHandler>
    </AudioProvider>
  );
};

export const wrapRootElement = ({ element }) => {
  return (
    <RadioProvider>
     <AuthProvider>
      {element}
     </AuthProvider>
    </RadioProvider>
  );
};

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === "production") {
    const gtmScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';dl+='&cookie_flags=SameSite=None;Secure';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MQPCXHB');
  `;

    const gtmNoScript = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MQPCXHB" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;

    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.async = true;
    scriptTag.innerHTML = gtmScript;

    const noScriptTag = document.createElement("noscript");
    noScriptTag.innerHTML = gtmNoScript;

    document.head.appendChild(scriptTag);
    document.body.appendChild(noScriptTag);
  }

  const blockIds = ["R-A-2420038-7", "R-A-2420038-4", "R-A-2420038-1", "R-A-2420038-3"];
  window.yaContextCb = window.yaContextCb || [];
  
  const checkAndRenderAds = () => {
    blockIds.forEach((blockId) => {
      const containerId = `yandex_rtb_${blockId}`;
      const container = document.getElementById(containerId);
  
      if (container && !container.dataset.adRendered) {
        container.dataset.adRendered = "true"; // Помечаем, что реклама уже загружена
        
        window.yaContextCb.push(() => {
          window.Ya.Context.AdvManager.render({
            blockId: blockId,
            renderTo: containerId,
          });
        });
      }
    });
  };
  
  // Проверка на случай динамической загрузки контейнеров
  const observer = new MutationObserver(() => {
    checkAndRenderAds();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Запускаем при первой загрузке
  checkAndRenderAds();
};

